import { FC } from 'react'
import styles from './index.module.scss'
import { SettingsSidebarMenuItem } from '../../atoms/SettingsSidebarMenuItem'

type Props = {
  items: {
    label: string
    href: string
    isActive?: boolean
    isBelongingTo?: boolean
    isChecked?: boolean
  }[]
  withCheckmark?: boolean
}

export const SettingsSidebarMenu: FC<Props> = ({ items, withCheckmark }) => {
  if (withCheckmark) {
    const areNotBelongingTo = items.filter((i) => !i.isBelongingTo)
    return (
      <div className={styles.container}>
        <div className={styles.upperContent}>
          {items
            .filter((i) => i.isBelongingTo)
            .map((item) => (
              <SettingsSidebarMenuItem
                key={item.href}
                label={item.label}
                href={item.href}
                isActive={item.isActive}
                isChecked={item.isChecked}
                withCheckmark
              />
            ))}
        </div>
        {areNotBelongingTo.length > 0 && (
          <div className={styles.lowerContent}>
            {areNotBelongingTo.map((item) => (
              <SettingsSidebarMenuItem
                key={item.href}
                label={item.label}
                href={item.href}
                isActive={item.isActive}
                withCheckmark
              />
            ))}
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {items.map((item) => (
        <SettingsSidebarMenuItem key={item.href} label={item.label} href={item.href} isActive={item.isActive} />
      ))}
    </div>
  )
}
